import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from '../lib/CollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
